import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import { CartReplicateInput } from '@lib/graphql/graphql'

const cartReplicateMutationDocument = graphql(`
  mutation CartReplicate($input: CartReplicateInput!) {
    cartReplicate(input: $input) {
      cart {
        ...CartDetail
      }
      # errors {
      #   # ... on CartReplicationFailedError {
      #   #   message
      #   # }
      # }
    }
  }
`)

export const cartReplicate = async (input: CartReplicateInput) => {
  return await execute(cartReplicateMutationDocument, { input })
}
